import { put, takeLatest } from "redux-saga/effects";
import { requestProposalKPIS,requestSmartProposalReportKpis } from "../../../services/sales-pipeline/smartProposal";
import { requestSmartsuiteAgreementKpi } from "../../../services/kpi/";
import {
  requestProposalKpis,
  requestProposalKpisSuccess,
  requestProposalKpisFaliure,
  requestProposalReportKpis,
  requestProposalReportKpisSuccess,
  requestProposalReportKpisFaliure,
  fetchSmartSuiteAgreementKpisRequest,
  fetchSmartSuiteAgreementKpisSuccess,
  fetchSmartSuiteAgreementKpisFailure,
} from "redux/reducers/kpis";
export function* watchKpisSaga() {
  yield takeLatest(requestProposalKpis, smartProposalKPIS);
  yield takeLatest(requestProposalReportKpis, smartProposalReport);
  yield takeLatest(fetchSmartSuiteAgreementKpisRequest, smartSuiteAgreementKpis);
}

function* smartProposalKPIS({ payload }) {
  try {
    const response = yield requestProposalKPIS(payload);
    yield put(requestProposalKpisSuccess(response));
  } catch (error) {
    yield put(requestProposalKpisFaliure("Failed to get list of KPIS"));
  }
}
function* smartProposalReport({ payload }) {
  try {
    const response = yield requestSmartProposalReportKpis(payload);
    yield put(requestProposalReportKpisSuccess(response));
  } catch (error) {
    yield put(requestProposalReportKpisFaliure("Failed to get list of KPIS"));
  }
}

function* smartSuiteAgreementKpis({ payload }) {
  try {
    const response = yield requestSmartsuiteAgreementKpi(payload);
    yield put(fetchSmartSuiteAgreementKpisSuccess(response));
  } catch (error) {
    yield put(fetchSmartSuiteAgreementKpisFailure("Failed to get  Agreement list KPIs"));
  }
}
